import { render, staticRenderFns } from "./SkinDysfunctionsList.vue?vue&type=template&id=44e2629a&scoped=true"
import script from "./SkinDysfunctionsList.vue?vue&type=script&lang=js"
export * from "./SkinDysfunctionsList.vue?vue&type=script&lang=js"
import style0 from "./SkinDysfunctionsList.vue?vue&type=style&index=0&id=44e2629a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2629a",
  null
  
)

export default component.exports